
<div class="row">
  <div class="col-sm-3 p-sm-3">
      <h4>{{ title | i18n}} <help-link [target]="helpTarget"></help-link></h4>
  </div>
  <div class="col-sm text-sm-right p-sm-3 filter-group d-flex justify-content-end">
      <kendo-buttongroup [disabled]="isLoading" [selection]="'single'" *ngFor="let action of actions">
          <button kendoRippleContainer kendoButton fillMode="flat" [disabled]="isLoading" (click)="onFilterClick(action.id)" [selected]="selectedFilterId === action.id ? true : false">{{ action.displayName | i18n}}</button>
      </kendo-buttongroup>
  </div>
</div>
